import {PatchAdherenceDigitalPaymentParams} from 'domain/usecases';
import {makePatchAdherenceDigitalPayment} from 'main/factories/usecases';

export const patchAdherenceDigitalPayment = (params: PatchAdherenceDigitalPaymentParams) =>
	makePatchAdherenceDigitalPayment().patch(params);
